import React from 'react';
import { Button } from './ui/Button';
import { ArrowUpRight, Database, ShieldCheck, Globe } from 'lucide-react';
export function Hero() {
  return <div className="relative bg-white pt-32 pb-16 lg:pt-48 lg:pb-32 overflow-hidden" data-id="element-104">
      {/* Background Pattern */}
      <div className="absolute inset-0 z-0 opacity-[0.03]" style={{
      backgroundImage: 'radial-gradient(#1e293b 1px, transparent 1px)',
      backgroundSize: '32px 32px'
    }} data-id="element-105" />

      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-106">
        <div className="inline-flex items-center px-3 py-1 rounded-full bg-blue-50 text-blue-700 text-sm font-medium mb-8 border border-blue-100" data-id="element-107">
          <span className="flex h-2 w-2 rounded-full bg-blue-600 mr-2" data-id="element-108"></span>
          Independent Editorial Platform
        </div>

        <h1 className="text-4xl md:text-6xl lg:text-7xl font-bold text-slate-900 tracking-tight mb-6 leading-tight" data-id="element-109">
          Mastering <span className="text-blue-600" data-id="element-110">Data Infrastructure</span>{' '}
          <br className="hidden md:block" data-id="element-111" />& Digital Security
        </h1>

        <p className="mt-6 max-w-2xl mx-auto text-xl text-slate-600 leading-relaxed" data-id="element-112">
          Dataprixa writes detailed guides on web scraping, proxy networks, and
          cybersecurity. Our articles explain technical concepts in plain
          language and show you how to apply them to real projects.
        </p>

        <div className="mt-10 flex flex-col sm:flex-row justify-center gap-4" data-id="element-113">
          <a href="https://dataprixa.com" data-id="element-114">
            <Button icon data-id="element-115">Explore Our Research</Button>
          </a>
          <a href="#topics" data-id="element-116">
            <Button variant="outline" data-id="element-117">View Topics</Button>
          </a>
        </div>

        {/* Feature Highlights */}
        <div className="mt-20 grid grid-cols-1 md:grid-cols-3 gap-8 text-left max-w-5xl mx-auto" data-id="element-118">
          <div className="flex items-start space-x-4 p-6 rounded-2xl bg-slate-50 border border-slate-100" data-id="element-119">
            <div className="bg-white p-2 rounded-lg shadow-sm" data-id="element-120">
              <Database className="h-6 w-6 text-blue-600" data-id="element-121" />
            </div>
            <div data-id="element-122">
              <h3 className="font-semibold text-slate-900" data-id="element-123">Data Collection</h3>
              <p className="text-sm text-slate-600 mt-1" data-id="element-124">
                Proven methods for collecting data at scale.
              </p>
            </div>
          </div>

          <div className="flex items-start space-x-4 p-6 rounded-2xl bg-slate-50 border border-slate-100" data-id="element-125">
            <div className="bg-white p-2 rounded-lg shadow-sm" data-id="element-126">
              <Globe className="h-6 w-6 text-blue-600" data-id="element-127" />
            </div>
            <div data-id="element-128">
              <h3 className="font-semibold text-slate-900" data-id="element-129">
                Network Architecture
              </h3>
              <p className="text-sm text-slate-600 mt-1" data-id="element-130">
                Building reliable proxy systems that work.
              </p>
            </div>
          </div>

          <div className="flex items-start space-x-4 p-6 rounded-2xl bg-slate-50 border border-slate-100" data-id="element-131">
            <div className="bg-white p-2 rounded-lg shadow-sm" data-id="element-132">
              <ShieldCheck className="h-6 w-6 text-blue-600" data-id="element-133" />
            </div>
            <div data-id="element-134">
              <h3 className="font-semibold text-slate-900" data-id="element-135">Cybersecurity</h3>
              <p className="text-sm text-slate-600 mt-1" data-id="element-136">
                Security practices for data infrastructure.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>;
}